import BaseService from './base-service.js'
import { get } from 'lodash'

export default {
    async findImages({ imageIds }) {
        if (!get(imageIds, 'length')) return []
        const images = await BaseService.get(`/file/images`, {
            params: {
                imageIds,
            },
        })
        return get(images, 'data')
    },
}
